import { Component, OnInit } from '@angular/core';
import { MessageService } from '../_services/message.service';
import { CommonService } from 'src/app/_services/common.service';
import { HeaderData } from 'src/app/_models/header-data';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {

  private messages: Object;
  private outageMessages: Object;
  private loading: boolean = false;
  private filterObj: Object[];

  private important: boolean = false;
  private messageFilter: Object = {};

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  
  constructor(private messageService: MessageService, private commonService: CommonService) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    this.filterObj = [
      {filterIndex: 0, displayName : 'All', value: '', group: 'category'},
      {filterIndex: 1, displayName : 'Announcement', value: 'Announcement', group: 'category'},
      {filterIndex: 2, displayName : 'Notice', value: 'Notice', group: 'category'}  
    ];

    this.loading = true;
    this.messageService.getMessages().subscribe(data=>{
      this.loading = false;
      this.messages = data.messages;
      this.outageMessages = data.outageMessages;
    },
    error=>{
      this.loading = false;
      this.messages = null;
      this.outageMessages = null;
    });
    
  }

  setHeaderData(){
    this.headerData.pageTitle = "Messages";
    this.commonService.header = this.headerData;  
  }

  getFilteredData(_filter){
    if(_filter.filterIndex==0){
      delete this.messageFilter['category'];
    }else{
      this.messageFilter['category'] = _filter.value;
    }

    console.log(this.messageFilter);
    console.log(this.important);
  }

  getImportantData(){
    if(this.important){
      delete this.messageFilter['important'];
    }else{
      this.messageFilter['important'] = true;
    }
    console.log(this.messageFilter);
    console.log(this.important);
  }

}
